import { useState } from "react";
import styles from "./Service.module.css";
import IconContainer from "./IconContainer";

export default function Service({
    onClick = undefined,
    action = false,
    service,
}) {
    const [buttonHover, setButtonHover] = useState();

    return (
        <div className={styles.container} value={service} onClick={onClick}>
            <div className={styles.info}>
                <div className={styles.title}>{service.name}</div>
                <div className={styles.description}>
                    {service.description &&
                        service.description.map((item, i) => {
                            return (
                                <div
                                    key={i}
                                    className={styles[`description-item`]}
                                >
                                    {item}
                                </div>
                            );
                        })}
                </div>
                <div className={styles.price}>
                    {service.price} €{" "}
                    <span className={styles[`price-description`]}>
                        / {service.unity}
                    </span>
                </div>
            </div>

            {!(action === false) && (
                <div
                    className={`${styles.button} ${
                        styles[buttonHover === "enter" && `hover-enter`]
                    } ${styles[buttonHover === "leave" && `hover-leave`]}`}
                    onMouseOver={() => setButtonHover("enter")}
                    onMouseLeave={() => {
                        setButtonHover("leave");
                        setTimeout(() => {
                            setButtonHover("");
                        }, 300);
                    }}
                >
                    <div className={styles[`button-title`]}>Odaberi</div>
                </div>
            )}
            <IconContainer features={service.features} />
        </div>
    );
}
